// eslint-disable-next-line
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
export type History = typeof history;
